// extracted by mini-css-extract-plugin
module.exports = {"container":"FilterBox_container__2SmG6","link":"FilterBox_link__19nhM"};